module.exports = __webpack_public_path__ + "static/img/12@2x.cf49d74a.png";